













import { Component, Prop, Vue } from 'vue-property-decorator';
import { api } from '@sfs-projects/sfs-fc-api-sdk';
import router from "@/router";

@Component({
  name: 'Header'
})
export default class Header extends Vue {
  private selected = 'FRA';
  private options: any[] = [
    { value: 'FRA', text: 'FRA' },
    { value: 'BRU', text: 'BRU' }
  ]
  @Prop() isAuth!: boolean;

  logout (): void {
    api.Auth.logout();
    router.push({name: 'Login'});
  }
}
